// manual-variants.js - FIXED VERSION WITH DYNAMIC VARIANT IDS
console.log('Manual Variants JS Loaded');

document.addEventListener('DOMContentLoaded', function() {
  console.log('Initializing Manual Variant System');
  
  if (!window.manualVariantsData) {
    console.log('No manual variants data found');
    return;
  }
  
  // Handle manual variant button clicks
  document.addEventListener('click', function(e) {
    // Manual variant button click (size selection)
    const variantBtn = e.target.closest('.manual-variant-btn');
    if (variantBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleVariantClick(variantBtn);
      return;
    }
    
    // Manual add to cart button click
    const manualCartBtn = e.target.closest('.manual-add-to-cart');
    if (manualCartBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleManualAddToCart(manualCartBtn);
      return;
    }
  });
  
  function handleVariantClick(button) {
    console.log('Variant button clicked');
    
    const baseProductId = button.getAttribute('data-product-id');
    const shopifyProductId = button.getAttribute('data-shopify-product-id');
    const shopifyProductHandle = button.getAttribute('data-shopify-product-handle');
    const variantId = button.getAttribute('data-variant-id');
    const optionValue = button.getAttribute('data-option-value');
    
    console.log('Switching variant:', {
      baseProductId,
      shopifyProductId,
      shopifyProductHandle,
      variantId,
      optionValue
    });
    
    // Get product card
    const productCard = button.closest('.collection-switcher__product');
    if (!productCard) return;
    
    // Remove active class from all buttons in same option group
    const optionGroup = button.closest('.manual-option-group');
    if (optionGroup) {
      optionGroup.querySelectorAll('.manual-variant-btn')
        .forEach(btn => btn.classList.remove('active'));
    }
    
    // Add active class to clicked button
    button.classList.add('active');
    
    // Update product display
    updateProductDisplay(productCard, baseProductId, variantId, shopifyProductId, shopifyProductHandle);
  }
  
  function updateProductDisplay(productCard, baseProductId, variantId, shopifyProductId, shopifyProductHandle) {
    const manualData = window.manualVariantsData?.[baseProductId];
    if (!manualData) {
      console.error('No manual data found for product:', baseProductId);
      return;
    }
    
    const selectedVariant = manualData.variants.find(v => v.id === variantId);
    if (!selectedVariant) {
      console.error('No variant found with ID:', variantId);
      return;
    }
    
    console.log('Updating display for variant:', {
      variantId: selectedVariant.id,
      price: selectedVariant.price,
      compare_price: selectedVariant.compare_price,
      title: selectedVariant.title,
      image: selectedVariant.image
    });
    
    // 1. Update product title
    const titleElement = productCard.querySelector('.collection-switcher__product-title');
    if (titleElement && selectedVariant.title) {
      titleElement.innerHTML = selectedVariant.title;
    }
    
    // 2. Update price
    const priceElement = productCard.querySelector('.manual-price-display');
    if (priceElement) {
      const priceInRupees = Number(selectedVariant.price);
      const comparePriceInRupees = selectedVariant.compare_price ? Number(selectedVariant.compare_price) : null;
      
      if (comparePriceInRupees && comparePriceInRupees > priceInRupees) {
        const discountPercent = Math.round(((comparePriceInRupees - priceInRupees) / comparePriceInRupees) * 100);
        
        priceElement.innerHTML = `
          <span class="collection-switcher__product-compare-price">₹${comparePriceInRupees.toLocaleString('en-IN')}</span>
          <span>₹${priceInRupees.toLocaleString('en-IN')}</span>
          <span class="collection-switcher__product-discount new-discount">${discountPercent}% OFF</span>
        `;
      } else {
        priceElement.innerHTML = `<span>₹${priceInRupees.toLocaleString('en-IN')}</span>`;
      }
    }
    
    // 3. Update add to cart button
    const addToCartBtn = productCard.querySelector('.manual-add-to-cart');
    if (addToCartBtn) {
      addToCartBtn.setAttribute('data-product-id', shopifyProductId);
      addToCartBtn.setAttribute('data-product-handle', shopifyProductHandle);
      addToCartBtn.setAttribute('data-variant-id', selectedVariant.id);
      addToCartBtn.setAttribute('data-variant-title', selectedVariant.title || '');
      addToCartBtn.setAttribute('data-shopify-variant-id', selectedVariant.shopify_variant_id);
      
      console.log('Updated Add to Cart button:', {
        customVariantId: selectedVariant.id,
        shopifyVariantId: selectedVariant.shopify_variant_id,
        title: selectedVariant.title
      });
      
      if (!selectedVariant.available) {
        addToCartBtn.innerHTML = '<span class="desktop-show" style="padding: 12px 8px;">OUT OF STOCK</span><span class="mobile-show" style="padding: 5px 1px;">OUT OF <br> STOCK</span>';
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('out-of-stock');
      } else {
        addToCartBtn.innerHTML = '<span class="desktop-show">ADD TO CART</span><span class="mobile-show">ADD</span>';
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('out-of-stock');
      }
    }
    
    // 4. Update image
    if (selectedVariant.image) {
      const productImageWrapper = productCard.querySelector('.collection-switcher__product-image-wrapper');
      if (productImageWrapper) {
        const productImage = productImageWrapper.querySelector('.collection-switcher__product-image');
        
        if (productImage) {
          productImage.style.opacity = '0.5';
          productImage.style.transition = 'opacity 0.3s ease';
          
          setTimeout(() => {
            productImage.src = selectedVariant.image;
            productImage.alt = selectedVariant.title || 'Product Image';
            
            setTimeout(() => {
              productImage.style.opacity = '1';
            }, 50);
          }, 200);
        }
      }
    }
  }
  
  function handleManualAddToCart(button) {
    if (button.disabled || button.classList.contains('out-of-stock')) return;
    
    const customVariantId = button.getAttribute('data-variant-id');
    const variantTitle = button.getAttribute('data-variant-title') || '';
    const shopifyVariantId = button.getAttribute('data-shopify-variant-id');
    
    if (!shopifyVariantId) {
        console.error('No shopify variant ID found');
        showNotification('Error: Unknown product variant', 'error');
        return;
    }
    
    const originalText = button.innerHTML;
    button.innerHTML = 'ADDING...';
    button.disabled = true;
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(shopifyVariantId),
        quantity: 1,
        properties: {
          '_manual_variant': 'true',
          '_custom_variant_id': customVariantId,
          '_variant_title': variantTitle
        }
      })
    })
    .then(response => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    })
    .then(data => {
      console.log('Manual variant added to cart:', data);
      button.innerHTML = 'ADDED ✓';
      button.style.background = '#4CAF50';
      showNotification(`${variantTitle} added to cart!`, 'success');
      updateCartCount();
      
      setTimeout(() => {
        button.innerHTML = originalText;
        button.style.background = '';
        button.disabled = false;
      }, 2000);
    })
    .catch(error => {
      console.error('Error adding manual variant:', error);
      button.innerHTML = 'ERROR';
      button.style.background = '#f44336';
      showNotification('Failed to add to cart', 'error');
      
      setTimeout(() => {
        button.innerHTML = originalText;
        button.style.background = '';
        button.disabled = false;
      }, 2000);
    });
  }
  
  function showNotification(message, type = 'success') {
    const existingNotifications = document.querySelectorAll('.manual-cart-notification');
    existingNotifications.forEach(notification => notification.remove());
    
    const notification = document.createElement('div');
    notification.className = `manual-cart-notification ${type}`;
    notification.innerHTML = `<div>${message}</div><a href="/cart" class="view-cart">View Cart</a>`;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.opacity = '0';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
  
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.querySelectorAll('.cart-count, [data-cart-count]').forEach(element => {
          element.textContent = cart.item_count;
        });
      })
      .catch(error => console.error('Error updating cart count:', error));
  }
  
  // Initialize default variant selections
  function initializeManualVariants() {
    console.log('Initializing manual variant displays...');
    
    setTimeout(() => {
      document.querySelectorAll('.collection-switcher__product').forEach(productCard => {
        const productId = productCard.getAttribute('data-product-id');
        
        if (productId && window.manualVariantsData && window.manualVariantsData[productId]) {
          console.log('Found manual variant product:', productId);
          
          // FIX: prefer the button already marked active (the one the server correctly
          // picked as the default in-stock size) instead of always grabbing the FIRST
          // size button in the DOM. Blindly using the first button silently overwrote
          // the correct default variant's price/title/Add to Cart state with whatever
          // the first-listed size was, even when that size was out of stock.
          const firstVariantBtn = productCard.querySelector('.manual-variant-btn.active') || productCard.querySelector('.manual-variant-btn');
          
          if (firstVariantBtn) {
            const variantId = firstVariantBtn.getAttribute('data-variant-id');
            const shopifyProductId = firstVariantBtn.getAttribute('data-shopify-product-id');
            const shopifyProductHandle = firstVariantBtn.getAttribute('data-shopify-product-handle');
            
            updateProductDisplay(productCard, productId, variantId, shopifyProductId, shopifyProductHandle);
          }
        }
      });
    }, 1000);
  }
  
  initializeManualVariants();
});
